"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _HashSet = _interopRequireDefault(require("../../../../../java/util/HashSet"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _Stack = _interopRequireDefault(require("../../../../../java/util/Stack"));

var _RightmostEdgeFinder = _interopRequireDefault(require("./RightmostEdgeFinder"));

var _TopologyException = _interopRequireDefault(require("../../geom/TopologyException"));

var _LinkedList = _interopRequireDefault(require("../../../../../java/util/LinkedList"));

var _Comparable = _interopRequireDefault(require("../../../../../java/lang/Comparable"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Envelope = _interopRequireDefault(require("../../geom/Envelope"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BufferSubgraph =
/*#__PURE__*/
function () {
  function BufferSubgraph() {
    _classCallCheck(this, BufferSubgraph);

    BufferSubgraph.constructor_.apply(this, arguments);
  }

  _createClass(BufferSubgraph, [{
    key: "clearVisitedEdges",
    value: function clearVisitedEdges() {
      for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
        var de = it.next();
        de.setVisited(false);
      }
    }
  }, {
    key: "getRightmostCoordinate",
    value: function getRightmostCoordinate() {
      return this._rightMostCoord;
    }
  }, {
    key: "computeNodeDepth",
    value: function computeNodeDepth(n) {
      var startEdge = null;

      for (var i = n.getEdges().iterator(); i.hasNext();) {
        var de = i.next();

        if (de.isVisited() || de.getSym().isVisited()) {
          startEdge = de;
          break;
        }
      }

      if (startEdge === null) throw new _TopologyException.default("unable to find edge to compute depths at " + n.getCoordinate());
      n.getEdges().computeDepths(startEdge);

      for (var i = n.getEdges().iterator(); i.hasNext();) {
        var de = i.next();
        de.setVisited(true);
        this.copySymDepths(de);
      }
    }
  }, {
    key: "computeDepth",
    value: function computeDepth(outsideDepth) {
      this.clearVisitedEdges();

      var de = this._finder.getEdge();

      var n = de.getNode();
      var label = de.getLabel();
      de.setEdgeDepths(_Position.default.RIGHT, outsideDepth);
      this.copySymDepths(de);
      this.computeDepths(de);
    }
  }, {
    key: "create",
    value: function create(node) {
      this.addReachable(node);

      this._finder.findEdge(this._dirEdgeList);

      this._rightMostCoord = this._finder.getCoordinate();
    }
  }, {
    key: "findResultEdges",
    value: function findResultEdges() {
      for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
        var de = it.next();

        if (de.getDepth(_Position.default.RIGHT) >= 1 && de.getDepth(_Position.default.LEFT) <= 0 && !de.isInteriorAreaEdge()) {
          de.setInResult(true);
        }
      }
    }
  }, {
    key: "computeDepths",
    value: function computeDepths(startEdge) {
      var nodesVisited = new _HashSet.default();
      var nodeQueue = new _LinkedList.default();
      var startNode = startEdge.getNode();
      nodeQueue.addLast(startNode);
      nodesVisited.add(startNode);
      startEdge.setVisited(true);

      while (!nodeQueue.isEmpty()) {
        var n = nodeQueue.removeFirst();
        nodesVisited.add(n);
        this.computeNodeDepth(n);

        for (var i = n.getEdges().iterator(); i.hasNext();) {
          var de = i.next();
          var sym = de.getSym();
          if (sym.isVisited()) continue;
          var adjNode = sym.getNode();

          if (!nodesVisited.contains(adjNode)) {
            nodeQueue.addLast(adjNode);
            nodesVisited.add(adjNode);
          }
        }
      }
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var graph = o;

      if (this._rightMostCoord.x < graph._rightMostCoord.x) {
        return -1;
      }

      if (this._rightMostCoord.x > graph._rightMostCoord.x) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      if (this._env === null) {
        var edgeEnv = new _Envelope.default();

        for (var it = this._dirEdgeList.iterator(); it.hasNext();) {
          var dirEdge = it.next();
          var pts = dirEdge.getEdge().getCoordinates();

          for (var i = 0; i < pts.length - 1; i++) {
            edgeEnv.expandToInclude(pts[i]);
          }
        }

        this._env = edgeEnv;
      }

      return this._env;
    }
  }, {
    key: "addReachable",
    value: function addReachable(startNode) {
      var nodeStack = new _Stack.default();
      nodeStack.add(startNode);

      while (!nodeStack.empty()) {
        var node = nodeStack.pop();
        this.add(node, nodeStack);
      }
    }
  }, {
    key: "copySymDepths",
    value: function copySymDepths(de) {
      var sym = de.getSym();
      sym.setDepth(_Position.default.LEFT, de.getDepth(_Position.default.RIGHT));
      sym.setDepth(_Position.default.RIGHT, de.getDepth(_Position.default.LEFT));
    }
  }, {
    key: "add",
    value: function add(node, nodeStack) {
      node.setVisited(true);

      this._nodes.add(node);

      for (var i = node.getEdges().iterator(); i.hasNext();) {
        var de = i.next();

        this._dirEdgeList.add(de);

        var sym = de.getSym();
        var symNode = sym.getNode();
        if (!symNode.isVisited()) nodeStack.push(symNode);
      }
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      return this._nodes;
    }
  }, {
    key: "getDirectedEdges",
    value: function getDirectedEdges() {
      return this._dirEdgeList;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BufferSubgraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparable.default];
    }
  }]);

  return BufferSubgraph;
}();

exports.default = BufferSubgraph;

BufferSubgraph.constructor_ = function () {
  this._finder = null;
  this._dirEdgeList = new _ArrayList.default();
  this._nodes = new _ArrayList.default();
  this._rightMostCoord = null;
  this._env = null;
  this._finder = new _RightmostEdgeFinder.default();
};